import { CircleHelp } from 'lucide-react';
import { Trans, useLingui } from '@lingui/react/macro';
import React from 'react';
import UDText from 'ud-ui/components/text';
import UDTippy from 'ud-ui/components/tippy';
import SizeItem from './size-item';
import { Header, IconWrapper, Inputs, MainBlock } from './styles';

interface IProps {
  readonly: boolean;
}

function SizeInputs(props: IProps) {
  const { t } = useLingui();
  // const redirectToManual = useCallback(() => {
  //   window.open(MANUAL, '_blank');
  // }, []);

  return (
    <MainBlock>
      <Header>
        <UDText type={'caption-1'} className={'text-Black24 flex-center'}>
          <Trans>Укажите размер экрана/холста</Trans>
        </UDText>
        <UDTippy
          content={
            <div>
              <Trans>
                Размер холста в редакторе и соотношение сторон экрана.
                <br />
                <br />
                Приложение автоматически подберёт подходящий размер: изображение будет масштабировано по ширине и высоте с сохранением
                соотношения сторон, рассчитанного по указанным значениям.
                <br />
                <br />
                Например:
                <br />
                • 1920 × 1080 — соотношение 16:9, подойдёт для широкоформатного экрана.
                <br />• 1080 × 1080 — соотношение 1:1, квадратный формат.
              </Trans>
            </div>
          }
        >
          <IconWrapper>
            <CircleHelp size={16} />
          </IconWrapper>
        </UDTippy>
      </Header>
      <Inputs>
        <SizeItem readonly={props.readonly} name={'width'} text={t`Ширина`} type={'text'} />
        <SizeItem readonly={props.readonly} name={'height'} text={t`Высота`} type={'text'} />
      </Inputs>
    </MainBlock>
  );
}

export default SizeInputs;
